import type { Board } from "../board";
import { getMobGoldValue } from "../economy/mobGoldValues";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import { SolidifiedHorned } from "../things/solidifiedHorned";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { WeakMob } from "../weakMob";
import { BasicAI } from "../ai/basicAI";
import type { XY } from "../xy";
import type { PhysicalThing } from "../physicalThing";
import { HornedCorpse } from "./hornedCorpse";

export class Horned extends WeakMob {
	static key = "Horned";
	private ai: BasicAI;

	constructor(xy: XY) {
		super(xy);
		this.ai = new BasicAI(this);
		this.ai.probabilityToBreakBlockWhenStuck = 0.11;
		this.ai.attackSoundSupplier = () => new Sound(SoundId.MOB_PHISICAL_ATTACK, this.xy);
		this.ai.noiseSoundSupplier = () => new Sound(SoundId.HORNED_SOUND, this.xy);
	}

	override getBloodParticleType(): ParticleType {
		return ParticleType.BLOOD;
	}

	override getBaseGoldValue(): number {
		return getMobGoldValue(Horned.key);
	}

	createSolidifiedVariant(): PhysicalThing | null {
		return new SolidifiedHorned(this.xy);
	}

	generateCorpse(): PhysicalThing | null {
		return new HornedCorpse(this.xy);
	}

	override generateDeathSound(): Sound {
		return new Sound(SoundId.HORNED_DIE);
	}

	processMobAction(_board: Board): void {
		this.ai.processTurn();
	}

	static deserialize(data: any): Horned {
		const h = new Horned(deserializeXY(data.xy));
		h.restoreMobFields(data);
		return h;
	}
}
